import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { queryParams, withQueryParams } from '../commonFunctions';

export const useQueryState = (paramName?: string, defaultValue?: string | number): [string, (newValue?: string) => void] => {
  const params = queryParams();
  const navigate = useNavigate();

  const [value, setValue] = useState(defaultValue || (paramName && params[paramName]));

  useEffect(() => {
    setValue(defaultValue || (paramName && params[paramName]));
  }, [defaultValue, paramName, params]);

  const onSetValue = (newValue?: string | number) => {
    paramName &&
      setTimeout(() => {
        navigate(
          withQueryParams('.', {
            [paramName]: newValue,
          })
        );
      });
  };

  return [value, onSetValue];
};
